module.exports = __webpack_public_path__ + "img/profile-pic.e0c17edc.png";